// import Card from '../property-card'
import React, { useEffect } from 'react'

import { Link } from 'gatsby'

import { useDispatch, useSelector } from 'react-redux'
import {
  getEnvironment,
  getTypes,
  getLocations,
  getServices,
  checkCurrentFilters,
} from '@helpers/helper.filters'
import useQueryProperties from '@hooks/useQueryProperties'
import useQuerySummary from '@hooks/useQuerySummary'
import { Property, RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { changeViewId } from '@slices/propertiesSlice'
import PaginatedItems from '@components/paginate/1'

const MOCKDATA = {
  propCard: '1',
}

const Grid_Properties_1 = (props: RealEstateDataPageComponentData) => {
  const { isDemo, global_data, is_wide, includeTag } = props
  const propCard = isDemo
    ? MOCKDATA.propCard
    : global_data?.content?.cardsProperties?.type_id || '1'

  const { filters, offset, orders, coordinates, polygonCoordinates, viewId }: StatePropertiesSlice =
    useSelector((state: { properties: StatePropertiesSlice }) => state.properties)
  const API_KEY = global_data.pageConfig.keys.tokko
  const { allSummaryData } = useQuerySummary({ API_KEY })
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
    tokkoKey: API_KEY,
    custom_tags: includeTag ? includeTag.map((tag) => Number(tag)) : [],
  })

  const isSSR = typeof window === 'undefined'
  const dispatch = useDispatch()
  const Card = require(`@components/cardsProperties/${propCard}`)?.default

  const MediaSeo = false

  useEffect(() => {
    scrollTo({ top: 0, behavior: 'smooth' })
  }, [properties])

  useEffect(() => {
    if (viewId == 0) {
      // dispatch(changeViewId(2))
    }
  }, [])

  const order_properties_mediacore = (properties: Property[]) => {
    if (API_KEY) {
      return properties
    }
    let properties_order = properties?.map((prop) => prop)
    switch (orders?.order_by) {
      case 'id': {
        let response = properties_order?.sort((a, b) => a.id - b.id)
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      case 'price': {
        let response = properties_order?.sort(
          (a: Property, b: Property) =>
            a.operations.find(
              (op) =>
                op.operation_type?.toLowerCase() ===
                filters.operation?.toLowerCase().replace('temporario', 'alquiler temporario'),
            )?.prices.price -
            b.operations.find(
              (op) =>
                op.operation_type?.toLowerCase() ===
                filters.operation?.toLowerCase().replace('temporario', 'alquiler temporario'),
            )?.prices.price,
        )
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      case 'total_surface': {
        let response = properties_order.map((prop) => ({
          ...prop,
          surface_to_filter:
            prop.type.name === 'Campo' || prop.type.name === 'Terreno'
              ? prop.surface
              : prop.total_surface,
        }))
        response = response.sort((a: any, b: any) => a.surface_to_filter - b.surface_to_filter)
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      default:
        return properties
    }
  }

  return (
    <>
      <Container fluid={is_wide ? false : true}>
        <Row>
          <Col>
            <section id="results">
              <Row className="gx-lg-5 list d-flex justify-content-start ">
                <Col
                  className={
                    properties?.objects?.length === 0 && !isLoadingProperties ? '' : ' d-none'
                  }
                >
                  <div className={'alert alert-info '}>
                    No se encontraron resultados para su búsqueda.
                  </div>
                </Col>
                {isLoadingProperties || isFetchingProperties
                  ? [1, 2, 3, 4, 5, 6].map((index) => (
                      <Col
                        key={index}
                        lg={4}
                        className="mb-3 px-lg-4 mb-lg-4"
                      >
                        {!isSSR && (
                          <Card
                            skeleton={true}
                            global_data={global_data}
                          />
                        )}
                      </Col>
                    ))
                  : order_properties_mediacore(properties?.objects!)?.map((item, index) => (
                      <Col
                        key={index}
                        lg={4}
                        className={'mb-5 mb-lg-4 ' + (is_wide ? 'px-lg-4' : 'px-lg-5')}
                      >
                        {!isSSR && (
                          <Card
                            property={item}
                            global_data={global_data}
                          />
                        )}
                      </Col>
                    ))}
                <div className="my-lg-5 my-4">
                  <PaginatedItems
                    viewId={viewId}
                    global_data={global_data}
                  />
                </div>
              </Row>
            </section>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Grid_Properties_1
